import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '../views/HomeView.vue';
import AssociatedBuilders from '../views/AssociatedBuilders.vue';
import BuyerView from '../views/BuyerView.vue';
import AboutView from '../views/AboutView.vue';
import ContactView from '../views/ContactView.vue';
import NotFoundView from '../views/NotFoundView.vue';
import PrivacyPolicyView from '../views/PrivacyPolicyView.vue';
import CookiePolicyView from '../views/CookiePolicyView.vue';
import { applySeo } from '@/utils/seo';

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: {
      seo: {
        // Home keeps the full default title, so no `title` key here.
        description:
          'Clients Preferred Property Hub is a trust-driven real estate consultancy for Tricity. Verified GMADA and RERA approved projects in Mohali, Kharar, Chandigarh and Panchkula, with expert guidance for homebuyers and investors.',
        keywords:
          'real estate consultant Mohali, property dealer Kharar, RERA approved projects Tricity, GMADA approved plots, flats in Mohali, property in Chandigarh',
      },
    },
  },
  {
    path: '/associatedbuilders',
    name: 'associatedbuilders',
    component: AssociatedBuilders,
    meta: {
      seo: {
        title: 'Associated Builders & Projects in Tricity',
        breadcrumb: 'Associated Builders',
        description:
          'Browse the premium residential and commercial projects we represent across Mohali, Kharar and Chandigarh, from verified builders with GMADA and RERA approvals.',
        keywords:
          'builders in Mohali, residential projects Kharar, commercial projects Tricity, RERA approved builders Punjab',
      },
    },
  },
  {
    path: '/buyer',
    name: 'buyer',
    component: BuyerView,
    meta: {
      seo: {
        title: 'Property Buying & Investment Guides',
        breadcrumb: 'Buyer Guides',
        description:
          'Step-by-step guidance for first-time homebuyers and investors in Tricity: documentation checks, approvals, budgeting, location selection and expected returns.',
        keywords:
          'how to buy property in Mohali, first time home buyer guide India, real estate investment Tricity, property documents checklist',
      },
    },
  },
  {
    path: '/about',
    name: 'about',
    component: AboutView,
    meta: {
      seo: {
        title: 'About Us & Leadership',
        breadcrumb: 'About Us',
        description:
          'Meet the team behind Clients Preferred Property Hub, led by founder Vipandeep Singh, and the transparency-first approach we bring to every property transaction in Tricity.',
        keywords:
          'Vipandeep Singh real estate, Clients Preferred Property Hub team, trusted property consultant Mohali',
      },
    },
  },
  {
    path: '/contactus',
    name: 'contactus',
    component: ContactView,
    meta: {
      seo: {
        title: 'Contact Us',
        breadcrumb: 'Contact Us',
        description:
          'Talk to Clients Preferred Property Hub about buying, selling or investing in Tricity property. Office at Gillco Valley, Sector 127, Kharar, Mohali.',
        keywords:
          'contact property consultant Mohali, real estate office Kharar, property enquiry Tricity',
      },
    },
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicyView,
    meta: {
      seo: {
        title: 'Privacy Policy',
        breadcrumb: 'Privacy Policy',
        description:
          'How Clients Preferred Property Hub collects, uses, shares and protects the personal information you send through this website.',
      },
    },
  },
  {
    path: '/cookie-policy',
    name: 'cookie-policy',
    component: CookiePolicyView,
    meta: {
      seo: {
        title: 'Cookie Policy',
        breadcrumb: 'Cookie Policy',
        description:
          'The cookies and local storage used on the Clients Preferred Property Hub website, what each category does, and how to change your preferences.',
      },
    },
  },
  {
    // Catch-all. Kept last so it only matches when nothing else does.
    path: '/:pathMatch(.*)*',
    name: 'notfound',
    component: NotFoundView,
    meta: {
      seo: {
        title: 'Page Not Found',
        description:
          'The page you were looking for is not available. Browse our Tricity projects, buyer guides or get in touch with Clients Preferred Property Hub.',
        noindex: true,
      },
    },
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    return { top: 0 };
  },
});

router.afterEach((to) => {
  applySeo({ ...(to.meta && to.meta.seo ? to.meta.seo : {}), path: to.path });
});

export default router;
